import { render, staticRenderFns } from "./TreatmentReferral.vue?vue&type=template&id=55b1a6bc"
import script from "./TreatmentReferral.vue?vue&type=script&lang=js"
export * from "./TreatmentReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports